import { ApiPaths } from "../../../api/ApiPaths";
import { UserId } from "../../../../domain/user/UserId";
import { UserName } from "../../../../domain/user/UserName";
import { UserEmail } from "../../../../domain/user/UserEmail";
import { UserAccountRole } from "../../../../domain/user/account/UserAccountRole";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { ApiRequest } from "../../../api/ApiRequest";
import { UserPassword } from "../../../../domain/user/UserPassword";

export type GetUserListSuccessResponseType = {
    users: {
        id: string,
        name: string,
        email: string,
        role: string
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getUserList(): Promise<GetUserListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.userList,
        {},
        () => {},
        () => {});
}

export type GetUserInformationSuccessResponseType = {
    user: {
        id: string,
        name: string,
        email: string,
        role: string
    },
    viewableCareRecipients: [
        {
            id: string,
            name: string,
            houseId: string
        }
    ],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getUserInformation(
    userId: UserId
): Promise<GetUserInformationSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.userInformation.replace(/\{userId\}/g, userId.value),
        {},
        () => {},
        () => {}
    );
}

export async function registerUserInformation(
    userName: UserName,
    userEmail: UserEmail,
    userPassword: UserPassword,
    role: UserAccountRole,
    viewableCareRecipients: CareRecipientId[],
    sendEmail: boolean
) {
    const body = {
        user: {
            name: userName.value,
            email: userEmail.value,
            password: userPassword.value,
            role: role
        },
        viewableCareRecipients: viewableCareRecipients.map(viewableCareRecipient => viewableCareRecipient.value),
        sendEmail: sendEmail
    };
    return await ApiRequest.post(
        ApiPaths.admin.userRegister,
        {},
        body,
        () => {},
        () => {}
    );
}

export async function updateUserInformation(
    userId: UserId,
    userName: UserName,
    viewableCareRecipients: CareRecipientId[]
) {
    const body = {
        user: {
            name: userName.value
        },
        viewableCareRecipients: viewableCareRecipients.map(viewableCareRecipient => viewableCareRecipient.value)
    };
    return await ApiRequest.post(
        ApiPaths.admin.userUpdate.replace(/\{userId\}/g, userId.value),
        {},
        body,
        () => {},
        () => {}
    );
}

export async function deleteUser(
    userId: UserId
) {
    return await ApiRequest.delete(
        ApiPaths.admin.userDelete.replace(/\{userId\}/g, userId.value),
        {},
        () => {},
        () => {}
    );
}
